import {
    AllEnterpriseModule,
    type ColDef,
    LicenseManager,
    ModuleRegistry,
} from "ag-grid-enterprise";
import { useContext } from "react";

import { AppDefaultInfoContext } from "helpers/globalContext/AppDefaultInfoContext";

import { type IAgGridColumn } from "commonComponents/utilities/AgGridReact/AgGridReact.types";

// Register ag-grid enterprise modules once, when this utility module first loads.
ModuleRegistry.registerModules([AllEnterpriseModule]);

/**
 * Sets the ag-grid enterprise license key from the app-default value. Call from every ag-grid
 * entry point (AgGridReact wrapper + components that render AgGridReact directly) so
 * the license is applied within ag-grid's own lazy chunk, before any grid renders.
 * Replaces the former eagerly-rendered <AGGridProvider>, which pinned ag-grid into the entry
 * bundle just to set this key.
 *
 * setLicenseKey is a cheap idempotent assignment on ag-grid's side, so calling it per grid
 * mount (as the old provider did per render) is fine and avoids render-time side effects on
 * module state.
 */
export const useAgGridLicense = () => {
    const licenseKey = useContext(AppDefaultInfoContext)?.aGGridLicenseKey;
    LicenseManager.setLicenseKey(licenseKey ?? "");
};

export const mapBTColToAgCol = (btCol: IAgGridColumn): ColDef => {
    return {
        aggFunc: btCol.aggFunc,
        field: btCol.jsonKey,
        headerName: btCol.name,
        sortable: btCol.isSortable,
        type: btCol.columnType ?? undefined,
        width: btCol.width,
        minWidth: btCol.minWidth,
    };
};
